import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/assets/icons/DownArrow.svg'


const _hoisted_1 = {
  class: "form-input",
  ref: "containerRef"
}
const _hoisted_2 = { class: "label-input" }
const _hoisted_3 = { class: "selected-option" }
const _hoisted_4 = { class: "select-options" }
const _hoisted_5 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", _hoisted_2, _toDisplayString(_ctx.label), 1),
    _createElementVNode("div", {
      class: _normalizeClass(["custom-select", { disabled: _ctx.isDisabled }]),
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleDropdown && _ctx.toggleDropdown(...args)))
    }, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.selectedLabel ||
          (_ctx.isDisabled ? "Deshabilitado" : "Selecciona el rol...")), 1),
      _createElementVNode("img", {
        class: _normalizeClass(["select-arrow", { rotated: _ctx.isOpen }]),
        src: _imports_0,
        alt: "arrow"
      }, null, 2),
      _withDirectives(_createElementVNode("ul", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option, index) => {
          return (_openBlock(), _createElementBlock("li", {
            key: index,
            class: "option-item",
            onClick: _withModifiers(($event: any) => (_ctx.selectOption(option)), ["stop"])
          }, _toDisplayString(_ctx.choiceMessage(option.enValue, option.esValue)), 9, _hoisted_5))
        }), 128))
      ], 512), [
        [_vShow, _ctx.isOpen && _ctx.options?.length]
      ])
    ], 2),
    _createElementVNode("p", {
      class: _normalizeClass([_ctx.hasError ? 'error' : 'no-error'])
    }, _toDisplayString(_ctx.hasError ? _ctx.error?.esMessage : ""), 3)
  ], 512))
}